// pages/VerifyEmail.jsx
import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api';
import Footer from '../components/Footer';

const VerifyEmail = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState('Vérification en cours...');
  const [error, setError] = useState(false);

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const res = await api.get(`/api/auth/verify-email/${token}`);
        setMessage(res.data.msg || 'Email vérifié avec succès !');
        // Redirect to login after a short delay
        setTimeout(() => navigate('/login'), 3000);
      } catch (err) {
        setError(true);
        setMessage(err.response?.data?.msg || 'Erreur lors de la vérification de l\'email');
      }
    };

    if (token) {
      verifyEmail();
    }
  }, [token, navigate]);

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: 'var(--app-background)' }}>
      <main className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md bg-white rounded-2xl shadow-lg p-8 text-center">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">
            Vérification d'Email
          </h2>
          <p className={`text-lg ${error ? 'text-red-600' : 'text-[var(--status-success)]'}`}>
            {message}
          </p>
          {!error && (
            <p className="text-gray-600 mt-4">
              Vous serez redirigé vers la page de connexion dans quelques secondes...
            </p>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default VerifyEmail;
